// stage refers to the environments the front-end or backend are running on
export var Stage;
(function (Stage) {
    Stage["Local"] = "local";
    Stage["Prod"] = "prod";
    Stage["Stage"] = "stage";
    Stage["Test"] = "test";
})(Stage || (Stage = {}));
export var BetbyBonusBehavior;
(function (BetbyBonusBehavior) {
    BetbyBonusBehavior["BonusExcluded"] = "BonusExcluded";
    BetbyBonusBehavior["NoBonusMoney"] = "NoBonusMoney";
    BetbyBonusBehavior["BonusMoney"] = "BonusMoney"; // Bonus Accounts can fully play sports
})(BetbyBonusBehavior || (BetbyBonusBehavior = {}));
export var CatalogFilter;
(function (CatalogFilter) {
    CatalogFilter["ReleaseGames"] = "ReleaseGames";
    CatalogFilter["AllGames"] = "AllGames";
    CatalogFilter["AllProviders"] = "AllProviders";
})(CatalogFilter || (CatalogFilter = {}));
export var EndpointType;
(function (EndpointType) {
    EndpointType["Stage1"] = "Stage1";
    EndpointType["Local"] = "Local";
    EndpointType["Production"] = "Production";
    EndpointType["ProdBlue"] = "ProdBlue";
    EndpointType["ProdRed"] = "ProdRed";
    EndpointType["ProdGreen"] = "ProdGreen";
    EndpointType["ProdMod"] = "ProdMod";
})(EndpointType || (EndpointType = {}));
// FeatureSet is a feature gate setting for preview and release features
export var FeatureSet;
(function (FeatureSet) {
    FeatureSet["Release"] = "Release";
    FeatureSet["Preview"] = "Preview";
})(FeatureSet || (FeatureSet = {}));
// Stage of release for the site
export var ReleaseStage;
(function (ReleaseStage) {
    ReleaseStage["General"] = "General";
    ReleaseStage["EarlyAccess"] = "EarlyAccess";
    ReleaseStage["Internal"] = "Internal";
    ReleaseStage["Gamma"] = "Gamma";
    ReleaseStage["Beta"] = "Beta";
    ReleaseStage["Alpha"] = "Alpha";
})(ReleaseStage || (ReleaseStage = {}));
export var AbTest;
(function (AbTest) {
    AbTest["A"] = "A";
    AbTest["B"] = "B";
    AbTest["C"] = "C";
    AbTest["D"] = "D";
})(AbTest || (AbTest = {}));
export var AppMode;
(function (AppMode) {
    AppMode["Mod"] = "mod";
    AppMode["Player"] = "player";
    AppMode["Public"] = "public";
    AppMode["Library"] = "library";
    AppMode["Admin"] = "admin";
})(AppMode || (AppMode = {}));
export const appModes = Object.keys(AppMode).map((key) => key.toLowerCase());
export var Theme;
(function (Theme) {
    Theme["Dynamic"] = "dynamic";
    Theme["Flush"] = "flush";
    Theme["Fomo"] = "fomo";
    Theme["Generic"] = "generic";
    Theme["Luna"] = "luna";
    Theme["Rocketbet"] = "rocketbet";
    Theme["Turboslots"] = "turboslots";
})(Theme || (Theme = {}));
/** Default rank config (numeric sublevels). Used when theme has no rankConfig. */
export const DEFAULT_RANK_CONFIG = {
    sublevelFormat: 'numeric'
};
